import React, { useState }  from 'react'
import axios from 'axios'
import { MdArrowLeft, MdArrowRight, MdKeyboardArrowRight,MdKeyboardArrowDown  } from "react-icons/md"
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function BookHotelRoomSimple() {
  const [scheduleDisplay,setScheduleDisplay] = useState(false)
  const [reservation_data, setReservation_data] = useState([])
  const [slotDisplay,setSlotDisplay] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [startDatePlusOneDay, setStartDatePlusOneDay] = useState('')
  const [endDate, setEndDate] = useState('')
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')
  function join(date, options, separator) {
    function format(option) {
      let formatter = new Intl.DateTimeFormat('en', option)
      return formatter.format(date)
    }
    return options.map(format).join(separator)
  }
  const today = join(new Date(), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const today_plus_1day_timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24)
  // user can book from 
  const today_plus_1day_format = join(new Date(today_plus_1day_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const today_plus_90days_timestamp = new Date().getTime()+(1000*60*60*24*90)
  const today_plus_90days_format = join(new Date(today_plus_90days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const onClick2CreateScheduleMenu = async()=>{
    setMsg('')
    setErr('')
    setStartDate('')
    setEndDate('')
    // let mtg_timesheet={}
    // for(let i1=3;i1<33;i1++){
    //   const timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24*i1)
    //   const format = join(new Date(timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
    //   mtg_timesheet[`${format}`] = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
    // } 
    // let reservation_data2 = ''
    try {
      const { data: res } = await axios.get(`${APIURL}/basic/book-hotel-room1`)
      console.log('aaa',res.info)
      // setReservation_data(res.info)
      // reservation_data2 = res.info
    } catch (err) {
      console.log(err)
    }
    // for(let i2 = 0; i2<Object.keys(reservation_data2).length;i2++){
    //   let dataset = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
    //   for(let i3 = 0; i3<Object.values(reservation_data2)[i2].length;i3++){
    //     if(Object.keys(Object.values(reservation_data2)[i2][i3])=="10.00-11.00"){
    //       dataset[0]={"10.00-11.00":"T"}
    //     }else if(Object.keys(Object.values(reservation_data2)[i2][i3])=="13.00-14.00"){
    //       dataset[1]={"13.00-14.00":"T"}
    //     }else{
    //       dataset[2]={"14.00-15.00":"T"}
    //     }
    //   }
    //   mtg_timesheet[Object.keys(reservation_data2)[i2]]=dataset
    // }
    // setSchedule(mtg_timesheet)
    setScheduleDisplay(true)
    }
  const onChange2StartDate = (e)=> { 
    const x = e.target.value
    setStartDate(x)
    function join(date, options, separator) {
      function format(option) {
        let formatter = new Intl.DateTimeFormat('en', option)
        return formatter.format(date)
      }
      return options.map(format).join(separator)
    }
    const startdate_plus_1day_timestamp = new Date(`${x.slice(5,7)}/${x.slice(8,10)}/${x.slice(0,4)}`).getTime()+(1000*60*60*24)
    const startdate_plus_1day_format = join(new Date(startdate_plus_1day_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
    setStartDatePlusOneDay(startdate_plus_1day_format)
  } 
  const onChange2EndDate = (e) => { 
      setEndDate(e.target.value)
  } 
  const onClick2CloseReservation = async()=>{
    setErr('')
    setMsg('')
    setStartDate('')
    setEndDate('')
    setScheduleDisplay(false)
  }
  const onClick2Submit = ()=>{
      setErr('')
      setMsg('')
      function join(date, options, separator) {
      function format(option) {
          let formatter = new Intl.DateTimeFormat('en', option)
          return formatter.format(date)
      }
      return options.map(format).join(separator)
     }
     const checkTerm = new Date(`${endDate.slice(5,7)}/${endDate.slice(8,10)}/${endDate.slice(0,4)}`).getTime()
      if(startDate==''){
        setErr('Please input start date.')
      }else if(endDate==''){
        setErr('Please input end date.')
      }else{
        setMsg(`You are successfully booked. Your reservation is ${new Date(startDate).toLocaleDateString("en-US", { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })} - ${new Date(endDate).toLocaleDateString("en-US", { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}.`)
        setScheduleDisplay(false)
      }
  }
  return (
    <div>
      <div className='text-xs flex flex-col'>
      <button className='primary-btn w-fit mb-1' onClick={onClick2CreateScheduleMenu} disabled={scheduleDisplay}>Check available time</button>
      {scheduleDisplay?
      <>
      <div className='flex'>
        <div className='flex flex-col mr-2'>
          <label for='reservation_start_date'>Start Date</label>
          <input type='date' id='reservation_start_date' name='reservation_date' min={today_plus_1day_format} max={today_plus_90days_format} value={startDate}
          onChange={(x)=>onChange2StartDate(x)} 
          className={`${err!=''?'border-red-600':'border-gray-900'} border w-fit`}/>
        </div>
        <div className='flex flex-col'>
          <label for='reservation_end_date'>End Date</label>
          {/* set start date as startdate+1day */}
          <input type='date' id='reservation_end_date' name='reservation_date' min={startDatePlusOneDay}  value={endDate} 
          onChange={(x)=>onChange2EndDate(x)} 
          className={`${err!=''?'border-red-600':'border-gray-900'} border w-fit`}/>
        </div>
      </div>
      {err!='' ? <span className='text-xs text-red-700'>{err}</span>:''} 
      <div className='cursor-default flex text-[8px]' onClick={(()=> setSlotDisplay(!slotDisplay))}>See all available room {slotDisplay?<MdKeyboardArrowDown className='mt-auto mb-auto'/>:<MdKeyboardArrowRight className='mt-auto mb-auto' />}</div>
      <div className='flex'>
      <button className='primary-btn text-xs w-fit mt-1 mr-1' onClick={onClick2CloseReservation}>Cancel</button>
      <button className='primary-btn text-xs w-fit mt-1' onClick={onClick2Submit}>Submit</button>
      </div>
      </>:''}
      {msg!='' ? <span className='text-xs'>{msg}</span>:''} 
      </div>
    </div>
  )
}